export default class CtaLink {
  constructor() {
    let $CtaLink = $('.js-cta-clickable');
    let isXPMActivated;

    if (window.self !== window.top) {
      isXPMActivated = true;
    }

    if ($CtaLink.length && !isXPMActivated) {
      $CtaLink.each((index, element) => {
        $(element).click(e => {
          const link = $(e.target)
            .parents('.js-cta-clickable')
            .find('a');

          if (link) {
            const href = link.attr('href');
            const target = link.attr('target');

            if (target && target === '_blank') {
              const win = window.open(href, '_blank');

              return win.focus();
            }

            window.location.href = href;
          }
        });
      });
    }

    $CtaLink.find('a').on('click', event => {
      event.stopPropagation();
    });
  }
}
